import React from 'react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Card, CardContent } from '../components/ui/Card';

export const Display: React.FC = () => {
  return (
    <DashboardLayout
      title="HioMenu"
      subtitle="Pantalla de Visualización"
    >
      {/* Welcome Section */}
      <div className="mb-8">
        <Card>
          <CardContent>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-16 h-16 flex-shrink-0 bg-gradient-to-br from-red-600 to-red-700 rounded-2xl flex items-center justify-center shadow-lg">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5} preserveAspectRatio="xMidYMid meet">
                  <rect x="3" y="4" width="18" height="14" rx="2" ry="2" />
                  <line x1="7" y1="8" x2="17" y2="8" />
                  <line x1="7" y1="12" x2="17" y2="12" />
                  <line x1="7" y1="16" x2="13" y2="16" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="text-2xl font-bold text-gray-900 mb-1">Menú Digital</h2>
                <p className="text-gray-600">
                  Visualiza el menú digital de tu establecimiento en tiempo real.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Menu Display Area */}
      <Card>
        <CardContent>
          <div className="text-center py-16">
            <div className="w-24 h-24 bg-gradient-to-br from-red-100 to-red-200 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <svg className="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Menú Digital</h3>
            <p className="text-gray-600 mb-6">
              El menú digital se mostrará aquí cuando esté configurado y disponible.
            </p>
            <p className="text-sm text-gray-500">
              Esta pantalla está optimizada para mostrar el menú digital del establecimiento.
            </p>
          </div>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};
